module.exports = __webpack_public_path__ + "img/base_hebergements_ferme.c1a5440b.svg";